import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

import useProductDetails from '@/components/product/ProductDetails/useProductDetails';

const ProductDetailsDesktop = dynamic(() => import('@/components/product/ProductDetails/ProductDetailsDesktop'));
ProductDetailsDesktop.displayName = 'ProductDetailsDesktop';
const ProductDetailsMobile = dynamic(() => import('@/components/product/ProductDetails/ProductDetailsMobile'));
ProductDetailsMobile.displayName = 'ProductDetailsMobile';

const ProductDetails = ({
  t,
  product,
  storeConf,
  ratingOrder,
  isDesktop,
  productAndItemAttributes,
  attributesRef
}) => {
  const productInfo = useProductDetails(product, ratingOrder);

  return isDesktop ? (
    <ProductDetailsDesktop
      t={t}
      product={product}
      productInfo={productInfo}
      productAndItemAttributes={productAndItemAttributes}
      attributesRef={attributesRef}
    />
  ) : (
    <ProductDetailsMobile
      t={t}
      productInfo={productInfo}
      product={product}
      storeConf={storeConf}
      productAndItemAttributes={productAndItemAttributes}
    />
  );
};

ProductDetails.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  storeConf: PropTypes.object.isRequired,
  ratingOrder: PropTypes.array.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  productAndItemAttributes: PropTypes.array,
  attributesRef: PropTypes.object
};

export default ProductDetails;
